import React from 'react';
import { Dropdown } from 'semantic-ui-react';
import $ from "jquery";
import Server from '../../functions/server';
import Loading from '../loading';

class Title extends React.Component {

  state = {
    selectedControl: [],
  }

  componentDidMount() {
    this.setControl();
  }

  componentDidUpdate(props) {
    if (props.eid != this.props.eid) {
      this.setControl();
    }
  }

  setControl() {
    console.log(this.props.data);
    console.log('sxsxsxsxsx');
    this.setState({ selectedControl: this.props.data  })
  }

  executive = (f, { value }) => {
    if (!this.props.menuPermission.edit) {
      alert('Access Denied!!!!');
      return;
    }
    this.check(value, this.state.selectedControl);
    this.setState({ selectedControl: value });
  }


  check(value, oldValue) {
    let length = value.length;
    if (length > oldValue.length) {
      let x = (value[value.length - 1]);
      this.add(x);
    } else if (length < oldValue.length) {
      let array1 = oldValue.filter(val => !value.includes(val));
      this.remove(array1[0]);
    }
  }

  remove(value) {
    let context = this;
    let data = {'cid': value, 'eid': this.props.eid};
    context.setState({
      load: true,
      message: 'Adding Executive!!!'
    })
    let url = Server() + 'statementmapping/remove.php';
    $.ajax({
      type: 'POST',
      data: data,
      url: url,
      success: function(data)
      {
        context.setState({
          load: false,
        })
        if (data == 1) {
          context.setState({
            load: false,
          })
        }
      },
      error: function(e)
      {
        context.setState({
          load: false,
        })
      }
    });
  }

  add(value) {
    let context = this;
    let data = {'cid': value, 'eid': this.props.eid};
    context.setState({
      load: true,
      message: 'Adding Executive!!!'
    })
    let url = Server() + 'statementmapping/insert.php';
    $.ajax({
      type: 'POST',
      data: data,
      url: url,
      success: function(data)
      {
        console.log(data);
        context.setState({
          load: false,
        })
        if (data == 1) {
          console.log('success');
          context.setState({
            load: false,
          })
        }
      },
      error: function(e)
      {
        console.log(e);
        context.setState({
          load: false,
        })
      }
    });
  }


  render() {
    return (
      <div>
      <Dropdown fluid multiple
        id="Executive" onChange={this.executive}
        search selection options={this.props.allCustomerOption}
        value={this.state.selectedControl} fluid style={{ borderColor: '#5A9CBB' }} />
      </div>
    );
  }
}

export default Title;
